import * as _ from 'lodash'
import {PlanTypeBO} from "./PlanTypeBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {WB_PlanTypeEventTypeRow, WB_PlanTypeFundTypeRow} from "../PA.Core/PAdbSchemaRows";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";


export class PlanTypeBOValidations {


    static async ValidateEmptyFields(aBO: PlanTypeBO): Promise<void> {
        let pt = aBO.WB_PlanType.cif

        // Validate Plan Type ID
        ErrorMessage_restate(aBO.ValidateMessageProvider,
            (_.isEmpty(aBO.WB_PlanType.cif.PLANM_ID) || _.isNull(aBO.WB_PlanType.cif.PLANM_ID)),
            'EmptyId', 'Plan Type ID cannot be empty'
        )

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            _.isEmpty(aBO.WB_PlanType.cif.PLANM_NAME),
            'EmptyName', 'Plan Name cannot be empty'
        )


        let bInvalidDate = (aBO.WB_PlanType.cif.VALID_FROM == "0NaNNaNNaN" || aBO.WB_PlanType.cif.VALID_THRU == "0NaNNaNNaN")
        ErrorMessage_restate(aBO.ValidateMessageProvider, bInvalidDate,
            'EmptyValidDateRange', 'Plan Type Valid Date(s) cannot be empty')

        let bValidDate = (_.isDate(new Date(aBO.WB_PlanType.cif.VALID_FROM)) && _.isDate(new Date(aBO.WB_PlanType.cif.VALID_THRU)))
        ErrorMessage_restate(aBO.ValidateMessageProvider, !bValidDate,
            'ValidDateIsNotDate', 'Valid from/thru dates must be a date')

        let bOutOfOrderDates = (bValidDate && aBO.WB_PlanType.ValidThru < aBO.WB_PlanType.ValidFrom)
        ErrorMessage_restate(aBO.ValidateMessageProvider, bOutOfOrderDates,
            'ValidDateOrderingIncorrect', 'Valid from date must be before the valid thru date')

        let bEmptyStartDate = false
        let bEmptyEndDate = false
        let bDateOrderingIncorrect = false

        _.forEach(_.filter(aBO.WB_PlanType.WB_PlanTypeEventTypeRows, (x: WB_PlanTypeEventTypeRow) => x.isActive), (aRow) => {

            if (_.isEmpty(aRow.cif.EFFECTIVE_START_DT)) {
                bEmptyStartDate = true
            }

            if (_.isEmpty(aRow.cif.EFFECTIVE_END_DT)) {
                bEmptyEndDate = true
            }

            if (_.isDate(aRow.EffectiveStartDt) && _.isDate(aRow.EffectiveEndDt)) {
                if (aRow.EffectiveEndDt < aRow.EffectiveStartDt) {
                    bDateOrderingIncorrect = true
                }
            }

        })



        ErrorMessage_restate(aBO.ValidateMessageProvider, bDateOrderingIncorrect,
            'EventDateOrderingIncorrect', 'Effective start date must be before the effective end date')


        ErrorMessage_restate(aBO.ValidateMessageProvider, bEmptyStartDate,
            'EventEmptyStartDate', 'Effective Start Date cannot be empty in Plan Type Event Type')


        ErrorMessage_restate(aBO.ValidateMessageProvider, bEmptyEndDate,
            'EventEmptyEndDate', 'Effective End Date cannot be empty in Plan Type Event Type')


        bEmptyStartDate = false
        bEmptyEndDate = false
        bDateOrderingIncorrect = false


        _.forEach(_.filter(aBO.WB_PlanType.WB_PlanTypeFundTypeRows, (x: WB_PlanTypeFundTypeRow) => x.isActive), (aRow) => {


            if (_.isEmpty(aRow.cif.EFFECTIVE_START_DT)) {
                bEmptyStartDate = true
            }
            if (_.isEmpty(aRow.cif.EFFECTIVE_END_DT)) {
                bEmptyEndDate = true
            }

            if (_.isDate(aRow.EffectiveStartDt) && _.isDate(aRow.EffectiveEndDt)) {
                if (aRow.EffectiveEndDt < aRow.EffectiveStartDt) {
                    bDateOrderingIncorrect = true
                }
            }
        })

        ErrorMessage_restate(aBO.ValidateMessageProvider, bDateOrderingIncorrect,
            'FundDateOrderingIncorrect', 'Effective start date must be before the effective end date')


        ErrorMessage_restate(aBO.ValidateMessageProvider, bEmptyStartDate,
            'FundEmptyStartDate', 'Effective Start Date cannot be empty in Plan Type Fund Type')


        ErrorMessage_restate(aBO.ValidateMessageProvider, bEmptyEndDate,
            'FundEmptyEndDate', 'Effective End Date cannot be empty in Plan Type Fund Type')

        // Validate CubeSource
        let bNoCubeSource = (aBO.WB_PlanType.bUseHyperRectangleInd && !(aBO.WB_PlanType.cif.WB_CUBESOURCE_ID > 0))
        ErrorMessage_restate(aBO.ValidateMessageProvider, bNoCubeSource,
            'NoCubeSource', 'CubeSource required for Hyper Rectangle UI')


        ErrorMessage_restate(aBO.ValidateMessageProvider, (!(pt.WB_BUSINESSUNIT_ID > 0)),
            'NoBusinessUnit', 'Business Unit cannot be empty')


        ErrorMessage_restate(aBO.ValidateMessageProvider, _.isEmpty(pt.QUANTITY_UOM),
            'NoUOM', 'Quantity UOM cannot be empty')

        ErrorMessage_restate(aBO.ValidateMessageProvider, _.isEmpty(pt.CURRENCY),
            'NoCurrency', 'Currency cannot be empty')

        ErrorMessage_restate(aBO.ValidateMessageProvider, (!(pt.WB_CUSTH_ID > 0)),
            'NoCustomerHierarchy', 'Customer Hierarchy cannot be empty')

        ErrorMessage_restate(aBO.ValidateMessageProvider, (!(pt.WB_PRDH_ID > 0)),
            'NoProductHierarchy', 'Product Hierarchy cannot be empty')

        ErrorMessage_restate(aBO.ValidateMessageProvider, _.isEmpty(pt.PRDGRP_LEVEL_ID),
            'NoProductGroupLevel', 'Product Group Level cannot be empty')

        ErrorMessage_restate(aBO.ValidateMessageProvider, (!(pt.WB_PERIODH_ID > 0)),
            'NoPeriodHierarchy', 'Period Hierarchy cannot be empty')

        ErrorMessage_restate(aBO.ValidateMessageProvider, (!(pt.WB_PERIODH_ID_MONTH > 0)),
            'NoPeriodHierarchyMonth', 'Period Hierarchy Month cannot be empty')

        ErrorMessage_restate(aBO.ValidateMessageProvider, (!(pt.WB_PERIODM_ID > 0)),
            'NoPeriodType', 'Period Type cannot be empty')

        ErrorMessage_restate(aBO.ValidateMessageProvider, (!(pt.WB_PERIODM_ID_MONTH > 0)),
            'NoPeriodTypeMonth', 'Period Type Month cannot be empty')

        ErrorMessage_restate(aBO.ValidateMessageProvider, _.isEmpty(pt.DISPLAY_HANDLING_METHOD_ID),
            'NoDisplayHandling', 'Display Handling cannot be empty')

        ErrorMessage_restate(aBO.ValidateMessageProvider, _.isEmpty(pt.PERIOD_ALLOC_METHOD_ID),
            'NoPeriodAllocation', 'Cross Week Allocation Policy cannot be empty')

        let bRequiresSubPlanningCustomer = false
        _.forEach(aBO.WB_PlanType.WB_PlanTypeEventTypeRows, (aRow) => {
            if (!(aRow.isActive && aRow.WB_EventTypeRow))
                return
            if(aRow.WB_EventTypeRow.bSubPlanningCustomerShowInd){
                bRequiresSubPlanningCustomer = true
                return false
            }
        })

        if(bRequiresSubPlanningCustomer){
            ErrorMessage_restate(aBO.ValidateMessageProvider, (!(pt.WB_CUSTH_ID_SUBPLANNING > 0)),
                'NoSubPlanningCustomerHierarchy', 'SubPlanning Customer Hierarchy cannot be empty')

            ErrorMessage_restate(aBO.ValidateMessageProvider, _.isEmpty(pt.SUBPLANNING_LEVEL_ID),
                'NoSubPlanningCustomerLevel', 'SubPlanning Customer Level cannot be empty')
        }

        let bMaxShipmentOffset= !((_.toNumber(pt.ACTUALIZATION_OFFSET_SHP) >= 0) && (_.toNumber(pt.ACTUALIZATION_OFFSET_SHP) <= 30))
        let bMaxIndirectShipmentOffset=!((_.toNumber(pt.ACTUALIZATION_OFFSET_INDSHP) >= 0) && (_.toNumber(pt.ACTUALIZATION_OFFSET_INDSHP) <= 30))
        let bMaxCnsOffset=!((_.toNumber(pt.ACTUALIZATION_OFFSET_CNS) >= 0) && (_.toNumber(pt.ACTUALIZATION_OFFSET_CNS) <= 30))

        ErrorMessage_restate(aBO.ValidateMessageProvider,bMaxShipmentOffset,
            'MaxShipmentOffset', 'Direct Shipment Actualization must be b/w 0 to 30')

        ErrorMessage_restate(aBO.ValidateMessageProvider,bMaxIndirectShipmentOffset ,
            'MaxIndShpOffset', 'Indirect Shipment Actualization must be b/w 0 to 30')

        ErrorMessage_restate(aBO.ValidateMessageProvider, bMaxCnsOffset,
            'MaxCnsOffset', 'Consumption Actualization must be b/w 0 to 30')

    }
}
